<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="helpPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="helpPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-user-shield"></i></span>{{ 'UserScope.Header.DataPermission' | translate }}
  </h1>
  <laas-user-preview [uuid]="userUuid"></laas-user-preview>
</div>
<help-dock
  [permissionCode]="helpPermissionCode"
  [lang]="currentLang">
</help-dock>
